import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { TipProblemaServiciiService } from '../tip-problema-servicii.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { TipProblemaServiciiActive } from '../tip-problema-servicii.interface';
import { TipProblemaService } from '../../tip-problema/tip-problema.service';
import { ServiciiService } from '../../servicii/servicii.service';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';

@Component({
    selector: 'app-add-tip-problema-servicii',
    templateUrl: './add-tip-problema-servicii.component.html',
    styleUrls: ['./add-tip-problema-servicii.component.scss']
})
export class AddTipProblemaServiciiComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    tipuriProblema!: any[];
    servicii!: any[];

    form: FormGroup = new FormGroup({
        id_problem_type: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_serviciu: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddTipProblemaServiciiComponent>,
        private tipProblemaServiciiActiveService: TipProblemaServiciiService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private tipProblemaService: TipProblemaService,
        private serviciiService: ServiciiService
    ) {
        this.processToken();
    }

    ngOnInit(): void {
        this.loadTipuriProblema();
        this.loadServicii();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.tipProblemaServiciiActiveService.setToken(token);
        });
    }

    loadTipuriProblema() {
        this.isLoading = true;
        this.tipProblemaService.getTipuriProblema().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.tipuriProblema = res;
            },
            error: (err) => {
                console.error('Error in get tipuri problema: ', err);
            }
        })
    }

    loadServicii() {
        this.isLoading = true;
        this.serviciiService.getServicii().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.servicii = res;
            },
            error: (err) => {
                console.error('Error in get servicii: ', err);
            }
        })
    }

    submitForm() {
        this.isLoading = true;

        const { id_problem_type, id_serviciu } = this.form.value as TipProblemaServiciiActive;

        const newTipProblemaServiciiActive: TipProblemaServiciiActive = {
            id_problem_type,
            id_serviciu
        };

        this.tipProblemaServiciiActiveService
            .addTipProblemaServiciiActive(newTipProblemaServiciiActive)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
